import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { reduceResolution, wbp } from 'Theme';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/V2/Button/Button';

interface Props {
    hasServices?: boolean;
    onAddService?: () => void;
    disableAddButton?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            [theme.breakpoints.down('md')]: {
                paddingLeft: 15,
                paddingRight: 15,
                flexDirection: 'column',
                position: 'relative'
            }
        },
        leftContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            marginLeft: 30,
            [theme.breakpoints.down('md')]: {
                marginLeft: 0,
                flexDirection: 'column',
                alignItems: 'flex-start'
            }
        },
        rightContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginRight: 30,
            [theme.breakpoints.down('md')]: {
                position: 'absolute',
                top: '-5px',
                right: 15,
                marginRight: 0
            }
        },
        title: {
            [theme.breakpoints.down('sm')]: {
                fontSize: 15,
                fontWeight: 500
            },
            [theme.breakpoints.only('md')]: {
                fontSize: 20,
                fontWeight: 600
            },
            [theme.breakpoints.only('lg')]: {
                fontSize: 27,
                fontWeight: 600
            },
            [theme.breakpoints.up('xl')]: {
                fontSize: 36,
                fontWeight: 600
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: 20,
                fontWeight: 600
            }
        },
        sort: {
            cursor: 'pointer',
            [theme.breakpoints.down('sm')]: {
                marginLeft: 22,
                fontSize: 28
            },
            [theme.breakpoints.only('md')]: {
                marginLeft: 30,
                fontSize: 20
            },
            [theme.breakpoints.only('lg')]: {
                marginLeft: 40,
                fontSize: 22
            },
            [theme.breakpoints.up('xl')]: {
                marginLeft: 54,
                fontSize: 24
            }
        },
        addServiceButton: {
            'paddingBottom': 30,
            'paddingTop': 30,
            '& .MuiButton-label': {
                fontWeight: 500
            },
            [theme.breakpoints.down('md')]: {
                'paddingBottom': 15,
                'paddingTop': 15,
                'display': 'inline-flex',
                'alignItems': 'center',
                'justifyContent': 'center',
                'height': 40,
                '& span': {
                    fontSize: 14,
                    fontWeight: '600'
                }
            }
        }
    })
);

export const ServicesHeader: FunctionComponent<Props> = props => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Box className={classes.leftContainer}>
                <Typography className={classes.title}>Primary Services</Typography>
            </Box>
            <Box className={classes.rightContainer}>
                {props.hasServices !== false ? (
                    <Button
                        leftIcon={faPlus}
                        label="Add Service"
                        id="services_button_add_service"
                        disabled={props.disableAddButton}
                        onClick={() => {
                            props.onAddService && props.onAddService();
                        }}
                    />
                ) : null}
            </Box>
        </Box>
    );
};

export default ServicesHeader;
